// Constants
import { MAX_DYNAMIC_FILTER_DESCRIPTION_LENGTH, MAX_DYNAMIC_FILTER_TITLE_LENGTH } from "../constants/DynamicFilterConstants";
import { DynamicFilterScopeType } from "../client/dynamicFilter/IDynamicFilterScope";
/**
 * Determine whether two scopes refer to the same surface.
 * @param a First scope to compare
 * @param b Second scope to compare
 */ export function areScopesEqual(a, b) {
    return a.type === b.type && a.id === b.id;
}
/**
 * Validate a dynamic filter, acting as the data-correctness gate before a filter is saved. Reports the
 * first failing field and lets the caller decide how to react.
 * @param filter The filter to validate
 * @returns A result flagging whether the filter is valid, with a reason when it is not. The error message is intended for telemetry and logging, make sure to not expose any PII or user data in it.
 */ export function validateDynamicFilter(filter) {
    if (filter.id.length === 0) {
        return {
            isValid: false,
            errorMessage: "DynamicFilter — id must not be empty"
        };
    }
    if (!Object.values(DynamicFilterScopeType).includes(filter.scope.type) || filter.scope.id.length === 0) {
        return {
            isValid: false,
            errorMessage: "DynamicFilter — scope is invalid"
        };
    }
    if (!Number.isFinite(filter.createdAt) || filter.createdAt <= 0) {
        return {
            isValid: false,
            errorMessage: "DynamicFilter — createdAt must be a positive timestamp"
        };
    }
    if (!Number.isFinite(filter.modifiedAt) || filter.modifiedAt <= 0) {
        return {
            isValid: false,
            errorMessage: "DynamicFilter — modifiedAt must be a positive timestamp"
        };
    }
    if (filter.modifiedAt < filter.createdAt) {
        return {
            isValid: false,
            errorMessage: "DynamicFilter — modifiedAt must not precede createdAt"
        };
    }
    const trimmedTitleLength = filter.title.trim().length;
    if (trimmedTitleLength === 0) {
        return {
            isValid: false,
            errorMessage: "DynamicFilter — title must not be empty"
        };
    }
    if (trimmedTitleLength > MAX_DYNAMIC_FILTER_TITLE_LENGTH) {
        return {
            isValid: false,
            errorMessage: `DynamicFilter — title exceeds the allowed length [max=${MAX_DYNAMIC_FILTER_TITLE_LENGTH}]`
        };
    }
    const trimmedDescriptionLength = filter.description.trim().length;
    if (trimmedDescriptionLength === 0) {
        return {
            isValid: false,
            errorMessage: "DynamicFilter — description must not be empty"
        };
    }
    if (trimmedDescriptionLength > MAX_DYNAMIC_FILTER_DESCRIPTION_LENGTH) {
        return {
            isValid: false,
            errorMessage: `DynamicFilter — description exceeds the allowed length [max=${MAX_DYNAMIC_FILTER_DESCRIPTION_LENGTH}]`
        };
    }
    return {
        isValid: true
    };
}
